import { useCallback } from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { cvSupportContact } from '@/utils/gtag'
import { trackMxEvent } from '@/utils/mixpanel'
import { Button } from '../ui/button'

type Props = {
  onContactClick?: () => void
}

export default function SupportContent({ onContactClick }: Props) {
  const onClickSupport = useCallback(() => {
    trackMxEvent('Support Contact Click')
    cvSupportContact()
    onContactClick?.()
  }, [ onContactClick ])

  return (
    <div className="w-full max-w-5xl md:flex md:items-center md:justify-center md:gap-10 lg:gap-40">
      <div className="mb-10 flex-none text-center md:order-2 md:my-0">
        <Image
          src="/images/support/support-lady.png"
          alt="support illustration"
          width={900}
          height={900}
          className="-mt-20 inline-block h-auto w-50 md:mt-0 md:w-72"
        />
      </div>
      <div className="md:order-1">
        <h2 className="mb-5 text-center md:text-left">
          初めての方も安心！<br />
          無料でサポートします
        </h2>
        <p className="mb-10">
          「何から始めたらいい?」「音楽制作ってどんなもの?」
          <br />
          運営スタッフが、あなたの疑問にしっかりお応えします。
          <br />
          まずは気軽にご相談ください。
        </p>
        <div className="text-center md:text-left">
          <Button
            className="h-12 w-full max-w-xs text-base font-semibold"
            onClick={onClickSupport}
            asChild
          >
            <Link href="/contact?category=music-support">
              お問い合わせはこちらから
            </Link>
          </Button>
        </div>
      </div>
    </div>
  )
}
